<template>
  <div class="banner grid">

    <div class="banner-actions text-center grid-bottom" :class="{ hidden: areActionsHidden }">
      <button class="btn btn-stretch btn-extra-round text-bold"
              :style="buttonStyle(firstOption.estilo)"
              @click="$emit('next', firstOption.id)">
        {{firstOption.nome}}
      </button>

      <button class="btn btn-stretch btn-extra-round text-bold second"
              v-if="options.length === 2"
              :style="buttonStyle(secondOption.estilo)"
              @click="$emit('next', secondOption.id)">
        {{secondOption.nome}}
      </button>
    </div>

  </div>
</template>

<script>
import buttonStyle from "../../../../interactions/components/interaction/mixins/button-style";
import dataInteractionProp from "../mixins/data-interaction-prop";

export default {
  props: {
    areActionsHidden: {
      type: Boolean,
      default: true,
    },
  },

  computed: {
    options() {
      return this.interaction.opcoes;
    },

    firstOption() {
      return this.options[0] || null;
    },

    secondOption() {
      return this.options[1] || null;
    },
  },

  mounted() {   
    if(Number(this.interaction.minimumTime) > 0) {
      this.$emit('on-countdown-init')
    }

    if(this.interaction.copyValue) {
      document.querySelector('.banner').addEventListener('click', (e) => {
        if (e.target.classList.contains('banner')) {
          navigator.clipboard.writeText(this.interaction.copyValue);
          this.$emit('on-copy', 'Texto copiado com sucesso!')
        }
      })
    }
  },

  mixins: [buttonStyle, dataInteractionProp],
};
</script>

<style lang="scss" scoped>
  .banner-actions {
    &.hidden {
      display: none !important;
    }
  }

  .btn {
    padding-left: 0;
    padding-right: 0;
  }
</style>


